import { Component, OnInit } from '@angular/core';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ToastrService } from 'ngx-toastr';
import { AssetService } from '../../services/asset-service';
import { Location } from '@angular/common';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';

@Component({
  selector: 'app-asset-barcode',
  templateUrl: './asset-barcode.component.html',
  styleUrls: ['./asset-barcode.component.scss']
})
export class AssetBarcodeComponent implements OnInit {


  serialNumber          : string;
  barCode               : string;
  serialNumberCheched   : boolean = false;
  alreadyProcessedAsset : Asset = null;
  processedAssetsCount  : number = 0;

  assets                : Asset[]=[];

  constructor(
    protected assetService        : AssetService,
    protected toastr              : ToastrService,
    public    leanUtilsService    : LeanUtilsService,
    protected location               : Location
  ) { }

  ngOnInit() {
  }

  serialNumberEntered(){
    this.barCode = null;
    this.checkSerialNumber();
  }


  barCodeEntered(){
    if ( !this.checkSerialNumber()){
        return;
    }

    if ( (this.leanUtilsService.barCodelength) && (this.barCode.length != this.leanUtilsService.barCodelength)){
      this.toastr.error("Longueur du code à barres invalide");
      return;
    }

    this.assetService.assetBarCodeSet(this.serialNumber, this.barCode) .then(result => {
      if (! this.alreadyProcessedAsset) {
        this.processedAssetsCount++;
      } else {
        this.alreadyProcessedAsset.rejected = true;
      }
      let asset : Asset = new Asset();
      asset.serialNumber  = this.serialNumber;
      asset.barCode       = this.barCode;
      asset.rejected      = false;
      this.assets.push(asset);

      this.serialNumber         = null;
      this.barCode              = null;
      this.serialNumberCheched  = false;
      this.alreadyProcessedAsset = null;
      this.toastr.success("Opérationn effectuée avec suucès");
    })

  }

  checkSerialNumber() : boolean{
    this.serialNumberCheched = false;
    if (! this.serialNumber){
      this.toastr.error("N° Série vide");
      return false;
    }
    if (this.serialNumber.trim() == ""){
      this.toastr.error("N° Série vide");
      return false;
    }
    if (  (this.leanUtilsService.serialNumberlength) &&  (this.serialNumber.length != this.leanUtilsService.serialNumberlength) ) {
      this.toastr.error("Longueur du N° Série invalide");
      return false;
    }

    this.alreadyProcessedAsset = null;
    for(let asset of this.assets){
      if (asset.serialNumber == this.serialNumber) {
        this.toastr.warning("Ce numéro de série vient d'être traité");
        this.alreadyProcessedAsset = asset;
        break;
      }
    }

    this.serialNumberCheched = true;
    return true;
  }


  close(){
    this.location.back();
  }

}
